import { BarChart3 } from 'lucide-react';

import { WidgetLayout } from '@/_containers';
import { dashboardWidgetsPermissionConfig } from '@/_shared';

export function Layout({
  children,
  className,
  fallback,
}: {
  children: React.ReactNode;
  className?: string;
  fallback?: React.ReactNode;
}) {
  return (
    <WidgetLayout
      title={dashboardWidgetsPermissionConfig['inventory_asset_value'].name}
      icon={BarChart3}
      viewAllLink="/inventory"
      viewAllText="View All Inventory"
      className={className}
      fallback={fallback}
    >
      {children}
    </WidgetLayout>
  );
}
